declare global {
    interface Window {
        dataLayer: unknown[]
    }
}

export const gtm: unknown[] = typeof window !== 'undefined' ? window.dataLayer || [] : []

gtm.push({
    event: 'gtm.js',
    'gtm.start': Date.now(),
})

if (typeof window !== 'undefined') {
    window.dataLayer = gtm
}
